<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">
        <a-card>
          <a-page-header
              :ghost="false"
              title="Pobierz adres MAC na podstawie adresu IP"
          >
            <a-row :gutter="[16, 16]">
              <a-col :span="8">
                <a-select v-model="selectedDorm" :loading="loadingDorms" style="width: 100%" :disabled="loadingMacAddress">
                  <a-select-option v-for="dorm in dorms" :key="dorm.code" :value="dorm.code" :disabled="dorm.code === 'master'">
                    {{ dorm.name }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="8">
                <a-input-search v-model="selectedIpAddress" placeholder="0.0.0.0" allow-clear :disabled="loadingMacAddress" :loading="loadingMacAddress"
                                @search="getMacByIp" enter-button="Pobierz" />
              </a-col>
              <a-col :span="8">
                <a-input-search v-model="response.output" placeholder="AA:BB:CC:DD:EE:FF" :loading="loadingMacAddress" class="text"
                                @search="copyToClipboard(response.output)">
                  <a-button slot="enterButton">
                    <a-icon type="copy"/>
                  </a-button>
                </a-input-search>
              </a-col>
            </a-row>
          </a-page-header>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import httpClient from "@/utils/httpClient";

export default {
  name: "Tools",
  data() {
    return {
      dorms: [],
      loadingDorms: true,
      loadingMacAddress: false,
      selectedDorm: null,
      selectedIpAddress: "",
      response: {
        output: "",
      },
    };
  },
  components: {},
  mounted() {
    this.$emit("loadedView");
    this.loadDorms();
  },
  methods: {
    loadDorms() {
      this.loadingDorms = true
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
            this.selectedDorm = this.dorms[0].code;
          }).catch(() => {
        this.$message.error("Wystąpił błąd z pobraniem listy węzłów!")
      }).finally(() => {
        this.loadingDorms = false
      })
    },

    getMacByIp() {
      this.loadingMacAddress = true
      httpClient
          .post(`/utils/remote/${this.selectedDorm}/scripts/mac-address`, {
            parameters: this.selectedIpAddress
          })
          .then((response) => {
            this.response = response;
            if (this.response.output === "") {
              this.$message.warn("Nie znaleziono adresu MAC dla podanego adresu IP!")
            }
          }).catch(() => {
        this.$message.error("Wystąpił błąd z pobraniem adresu IP!")
      }).finally(() => {
        this.loadingMacAddress = false
      })
    },

    copyToClipboard(output) {
      let textToCopy = document.querySelector(".text");
      const storage = document.createElement('textarea');
      storage.value = output;
      textToCopy.appendChild(storage);
      storage.select();
      storage.setSelectionRange(0, 99999);
      document.execCommand('copy');
      textToCopy.removeChild(storage);
      this.$message.success("Skopiowano do schowka!");
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  },
};
</script>
